import React, { useEffect, useRef, useState } from "react";

function Counter(props) {
  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");
  const [timeDifference, setTimeDifference] = useState(null)

  let interval = useRef();

  const startTimer = () => {
    const countdownDate = new Date(props.dateTime);

    interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;
      setTimeDifference(distance)

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        // Time's up, clear interval
        clearInterval(interval);
      } else {
        setTimerDays(days.toString().padStart(2, '0'));
        setTimerHours(hours.toString().padStart(2, '0'));
        setTimerMinutes(minutes.toString().padStart(2, '0'));
        setTimerSeconds(seconds.toString().padStart(2, '0'));
      }
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(interval.current);
    };
  },);

  return (
    <>
      {timeDifference < 0 ?
        <span>Bidding in Progress</span>
        :
        <div>
          <span id="days">{timerDays}</span>D :&nbsp;
          <span id="hours">{timerHours}</span>H :&nbsp;
          <span id="minutes">{timerMinutes}</span>M :&nbsp;
          <span id="seconds">{timerSeconds}</span>S
        </div>
      }

    </>
  );
}

export default Counter;

